import styled from "styled-components";

export const Container = styled.div`
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 4rem auto;
    >h2 {
        color: #666666;
        font-weight: 700;
        font-size: 2rem;
    }
    >button {
        font-size: 0.9rem;
        background: #00bf34;
        text-transform: uppercase;
        color: #FFF;
        font-weight: 500;
        width: 20%;
        padding: 0.7rem 0; 
    }
    >button#wait-btn {
        
        color: #666666;
        background: #FFF;
        border: 1px solid #666666;
        cursor: not-allowed;
    }

    >label#success-label {
        color: #00bf34;
        font-size: 0.8rem;
        padding-bottom: 0.75em;
    }

    @media(max-width: 767px) {
        >button {
            
            width: 50%;

        }
    }
`;

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 75%;
    margin: 4rem auto;

    >label {
        color: #666666;
        font-weight: 500;
        >strong {
            font-size: 0.7rem;
        }
    }
    >input{
        width: 100%;
        
        padding: 0.5rem;
        border: 1px solid #B6B6B6;
        margin: 0.5rem 0 2rem;
    }
    >p {
        font-size: 0.7rem;
    }
    .quill {
        width: 100%;
        height: 300px;
        margin: 0.5rem 0 4rem;
    }

    .guarantee-editor-placeholder {
        width: 100%;
        height: 300px;
        margin: 0.5rem 0 4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #B6B6B6;
        color: #666666;
        font-size: 0.875rem;
    }

    .ql-editor {
        strong {
            font-weight: bold;
        }
    }
`;

export const DocumentsContainer = styled.form`
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 8px;
    border: 1px solid #B6B6B6;
    margin: 8px 0 24px;
    >input{
        border: 0;
        
        padding: 8px;
        margin-top: 8px;
    }
`;

export const Document = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 8px;
    background: #6ea5ff;
    border-radius: 24px;
    margin-right: 8px;
    margin-top: 8px;
    >p{
        color: #FFF;
    }
    >button{
        margin-left: 8px;
    }
`;
